import { Cancel } from "@mui/icons-material";
import { IconButton, IconButtonProps } from "@mui/joy";

// Quiet remove button for list rows: muted until hovered, then danger red.
export default function DeleteIconButton({ sx, ...props }: Omit<IconButtonProps, "children">) {
  return (
    <IconButton
      variant="plain"
      color="neutral"
      size="sm"
      {...props}
      sx={[
        {
          // Neutral IconButtons paint the icon with text.icon, not currentColor.
          "--Icon-color": "currentColor",
          backgroundColor: "transparent",
          color: "neutral.500",
          "&:hover": { color: "danger.500", backgroundColor: "transparent" },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Cancel />
    </IconButton>
  );
}
